import { render, staticRenderFns } from "./PJProposalNamedLocations.vue?vue&type=template&id=043a7585"
import script from "./PJProposalNamedLocations.vue?vue&type=script&lang=js"
export * from "./PJProposalNamedLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports